// Reference: https://react-select.com/styles

// Default dark theme.
export const customStyle = {
  control: (provided) => ({
    ...provided,
    border: "none",
    borderRadius: "8px",
    boxShadow: "none",
    background: "#2b2929",
    color: "#f2f000",
    height: "50px",
  }),
  menu: (provided) => ({
    ...provided,
    padding: "0",
    background: "#070707",
    border: "1px solid #7d31b8",
  }),
  menuList: (provided) => ({
    ...provided,
    padding: "0",
    background: "#070707",
    border: "1px solid #7d31b8",
  }),
  option: (provided, state) => ({
    ...provided,
    borderBottom: "1px solid #2b2929",
    color: state.isSelected
      ? "#7d31b8"
      : state.isFocused
      ? "#7d31b8"
      : "#d2d2d2",
    padding: 20,
    margin: 0,
    background: "#070707",
  }),
  input: (provided) => ({
    ...provided,
    color: "#d2d2d2",
    paddingLeft: 28,
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#d2d2d2",
    padding: "0 0 0 28px",
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    border: "1px solid #7d31b8",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "#07b013",
  }),
};

// Light theme.
export const customStyleLight = {
  control: (provided) => ({
    ...provided,
    border: "1px solid black",
    borderRadius: "8px",
    boxShadow: "0 0 5px rgba(0, 0, 0, 0.8)",
    background: "white",
    color: "#f2f000",
    height: "50px",
  }),
  menu: (provided) => ({
    ...provided,
    padding: "0",
    border: "1px solid black",
  }),
  menuList: (provided) => ({
    ...provided,
    padding: "0",
    border: "1px solid black",
  }),
  option: (provided, state) => ({
    ...provided,
    borderBottom: "1px solid #003767",
    color: state.isSelected ? "#07b013" : state.isFocused ? "#07b013" : "black",
    padding: 20,
    margin: 0,
    background: "white",
  }),
  input: (provided) => ({
    ...provided,
    color: "black",
    paddingLeft: 28,
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "black",
    padding: "0 0 0 28px",
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    border: "1px solid #003767",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "#07b013",
  }),
};
